import React from "react";

import {styled} from "@styled-system/jsx";
import {button, icon, spinner} from "@styled-system/recipes";

import type {ButtonVariantProps} from "@styled-system/recipes";
import type {SystemStyleObject} from "@styled-system/types";

import {css, cx} from "@styled-system/css";

export type ButtonProps = ButtonVariantProps & //exported for toast
    React.ButtonHTMLAttributes<HTMLButtonElement> & {
        isLoading?: boolean;
        icon?: React.ReactNode;
        css?: SystemStyleObject;
    };

const Spinner = styled("div", spinner);
const IconWrapper = styled("span", icon);

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({children, className, isLoading, disabled, icon, variant, size, width, css: cssProp, ...props}, ref) => {
        return (
            <button
                ref={ref}
                disabled={disabled || isLoading}
                className={cx(button({variant, size, width}), className, cssProp && css(cssProp), className)}
                {...props}>
                <span className={css({display: "flex", alignItems: "center", pl: 2, pr: 1})}>
                    {isLoading && <Spinner size="sm" variant="thin" />}
                    {icon && <IconWrapper size="sm">{icon}</IconWrapper>}
                    {children}
                </span>
            </button>
        );
    }
);

Button.displayName = "Button";
